import Svg, { Path } from 'react-native-svg';

export interface GoatIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}

/**
 * A side-view goat outline (facing left), drawn to match lucide's icon
 * conventions: 24x24 viewBox, stroke only, round caps and joins. Lucide has
 * no goat, and the Grazing defense strategy needs one. Kept to a few simple
 * paths so it stays legible at the panel's 12px badge size: a shallow
 * capsule body, a neck up to a wedge of a head with the muzzle pointing down
 * and left, one back-swept horn, a beard, two legs and a short tail (redrawn
 * Oct 14 2026 after the first version read as a dog).
 */
export function GoatIcon({ size = 24, color = 'currentColor', strokeWidth = 2 }: GoatIconProps) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round">
      {/* Body: a shallow capsule from the shoulder to the rump */}
      <Path d="M8.5 10.5h7.5a3 3 0 0 1 3 3v1.5a1 1 0 0 1-1 1H8.5a2.5 2.5 0 0 1-2.5-2.5v-.5a2.5 2.5 0 0 1 2.5-2.5z" />
      {/* Neck up from the shoulder, then the head as a wedge, muzzle down and left */}
      <Path d="M7.5 11 6 7 2.5 9.5 5.5 11" />
      {/* One horn, swept up and back from the top of the head */}
      <Path d="M6 7c.3-2.5 1.8-3.8 3.5-3.5" />
      {/* Beard under the muzzle */}
      <Path d="M3.5 10.5v1.8" />
      {/* Two legs */}
      <Path d="M9.5 16v4M16.5 16v4" />
      {/* Tail */}
      <Path d="M19 11.5l2-2" />
    </Svg>
  );
}
